var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-divider',{attrs:{"position":"left"}},[_c('div',{staticClass:"vs-list--title"},[_vm._v("โครงการ "+_vm._s(_vm.roleInfo != null ? _vm.roleInfo.customer_name : ""))])])}
var staticRenderFns = []

export { render, staticRenderFns }